import * as Sentry from '@sentry/react';
import logger from '@/logger';

logger.info('Config.js::: ' + import.meta.env.MODE);

const isProduction = import.meta.env.PROD;
const serverUrl = import.meta.env.VITE_BPNYC_API_URL || 'http://localhost:8080';
const baseUrl = `${serverUrl}/api/admin/clients`;

const SENTRY_CONFIG = isProduction
	? {
			dsn:
				'https://473640a45b21f308e61ba6f3dd1c6a2d@o4504758958358528.ingest.us.sentry.io/4508303704588288',
			integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
			// Tracing
			tracesSampleRate: 1.0, //  Capture 100% of the transactions
			// Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
			tracePropagationTargets: ['localhost', /^https:\/\/server\.bluebirdadmin\.com/],
			// Session Replay
			replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
			replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
	  }
	: false; // Sentry will be disabled in development

export default {
	SENTRY_CONFIG,
	serverUrl,
	baseUrl,
	wsServerUrl: import.meta.env.VITE_BPNYC_WS_URL || 'http://localhost:4012',
	arCamLocalServerUrl: 'http://localhost:8005',
	arCamServerUrl: 'https://ar.bpdev.club',
	aiPhotoBoothServerUrl: isProduction
		? 'https://ai-photo-booth-server.bpdev.club'
		: 'http://localhost:8082',
	aiPhotoBoothClientUrl: isProduction
		? 'https://ai-photo-booth.bpdev.club'
		: 'http://localhost:3009',
	analytics: {
		googleTrackingId: 'UA-97293533-1',
	},
};
